module.exports = __webpack_public_path__ + "img/chevron.54c485c7.svg";